import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@material-ui/core/Dialog'

import ResultBlock from 'components/common/ResultBlock'

const ResultAlert = props => {
	const { t } = useTranslation();
	return (
		<Dialog open={props.open} onClose={props.onClose}>
			<ResultBlock status="succ" title="預約成功"/>
		</Dialog>
	)
}

export default ResultAlert
